export const form = {
  id: undefined,
  line_id: undefined, // 发布平台
  title: '', // 标题
  template_fields: {}
}

export const rules = {
  line_id: [
    { required: true, message: '请选择发布平台', trigger: ['change', 'blur'] }
  ],
  title: [
    { required: true, message: '请输入标题', trigger: ['change', 'blur'] }
  ],
}
